import type { ReactElement } from 'react';
// Minimal inline SVG icons (no icon-library dependency). All inherit currentColor.
import type { QuestionType } from '@/types';

type IconProps = { className?: string };

export function ListIcon({ className }: IconProps) {
  return (
    <svg viewBox="0 0 24 24" className={className} fill="none" stroke="currentColor" strokeWidth="2" aria-hidden>
      <circle cx="5" cy="7" r="1.5" /><circle cx="5" cy="17" r="1.5" />
      <line x1="10" y1="7" x2="20" y2="7" strokeLinecap="round" />
      <line x1="10" y1="17" x2="20" y2="17" strokeLinecap="round" />
    </svg>
  );
}

export function PencilIcon({ className }: IconProps) {
  return (
    <svg viewBox="0 0 24 24" className={className} fill="none" stroke="currentColor" strokeWidth="2" aria-hidden>
      <path d="M4 20h4L18 10l-4-4L4 16v4z" strokeLinejoin="round" />
      <path d="M14 6l4 4" strokeLinecap="round" />
    </svg>
  );
}

export function MicIcon({ className }: IconProps) {
  return (
    <svg viewBox="0 0 24 24" className={className} fill="none" stroke="currentColor" strokeWidth="2" aria-hidden>
      <rect x="9" y="3" width="6" height="11" rx="3" />
      <path d="M5 11a7 7 0 0 0 14 0M12 18v3" strokeLinecap="round" />
    </svg>
  );
}

export function ClockIcon({ className }: IconProps) {
  return (
    <svg viewBox="0 0 24 24" className={className} fill="none" stroke="currentColor" strokeWidth="2" aria-hidden>
      <circle cx="12" cy="12" r="9" />
      <path d="M12 7v5l3 2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export function LockIcon({ className }: IconProps) {
  return (
    <svg viewBox="0 0 24 24" className={className} fill="none" stroke="currentColor" strokeWidth="2" aria-hidden>
      <rect x="5" y="11" width="14" height="9" rx="2" />
      <path d="M8 11V8a4 4 0 0 1 8 0v3" strokeLinecap="round" />
    </svg>
  );
}

export function ScaffoldIcon({ className }: IconProps) {
  return (
    <svg viewBox="0 0 24 24" className={className} fill="none" stroke="currentColor" strokeWidth="2" aria-hidden>
      <path d="M4 20V5l8-2 8 2v15" strokeLinejoin="round" />
      <path d="M4 9h16M4 14h16M12 3v17" strokeLinecap="round" />
    </svg>
  );
}

export function typeIcon(type: QuestionType): (p: IconProps) => ReactElement {
  if (type === 'MCQ') return ListIcon;
  if (type === 'AUDIO') return MicIcon;
  return PencilIcon;
}

const TYPE_LABEL: Record<QuestionType, string> = {
  MCQ: 'Multiple choice',
  SHORT_DESC: 'Short answer',
  MEDIUM_DESC: 'Medium answer',
  LONG_DESC: 'Long answer',
  AUDIO: 'Audio answer',
};

export function typeLabel(type: QuestionType): string {
  return TYPE_LABEL[type];
}
